import { useTranslation } from 'react-i18next'
import promoTicketsImg from '../../assets/img/promo-tickets.png'
import { ButtonElement, ButtonLocation, trackButtonClick } from '../../utils/analyticsEvents'
import { Button } from '../Button/Button'
import styles from './PromoBanner.module.scss'

interface PromoBannerProps {
  onGetPromo: () => void
}

export const PromoBanner = ({ onGetPromo }: PromoBannerProps) => {
  const { t } = useTranslation()

  return (
    <section className={styles.banner}>
      <div className={`container ${styles.inner}`}>
        <div>
          <h2 className={styles.title}>{t('banner.title')}</h2>
          <p className={styles.subtitle}>{t('banner.subtitle')}</p>
          <Button
            animated
            arrow
            hoverBlend
            className={styles.cta}
            onClick={() => {
              trackButtonClick(ButtonElement.GetPromocode, ButtonLocation.Promo)
              onGetPromo()
            }}
          >
            {t('banner.cta')}
          </Button>
        </div>
        <img
          alt=""
          className={styles.image}
          height="300"
          loading="lazy"
          src={promoTicketsImg}
          width="300"
        />
      </div>
    </section>
  )
}
